<mat-expansion-panel
  [expanded]="true"
  *ngIf="testBenchSubItem === benchSubItemEnum.BenchStatus"
>
  <mat-expansion-panel-header>
    <div class="row" style="width: 100%">
      <div class="col-md-6">
        <h6>
          <mat-icon class="bosch-ic-settings"></mat-icon>
          {{ 'energy.testbenchOverview.title' | translate }}
        </h6>
      </div>
      <div class="col-md-6" style="text-align: right">
        <button
          id="running-efficiency"
          class="btn btn-primary"
          (click)="
            getRunningEfficiencyChartForLoad(benchSubItemEnum.BenchStatus)
          "
          matTooltip="{{ 'energy.testbenchOverview.btnTooltip' | translate }}"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="icon"
            class="bosch-ic-efficiency mat-icon Bosch-Ic"
            style="width: max-content"
          ></mat-icon>
          {{ 'energy.testbenchOverview.runningEfficiency' | translate }}
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
  <br />
  <div class="row">
    <ng-container *ngFor="let testBench of testBenchData; let $index = index">
      <div class="col-md-6">
        <div
          class="tile"
          fxLayout="row wrap"
          fxFlex="100%;"
          fxLayoutAlign="center center"
          (click)="getTestBenchImage(testBench)"
          style="flex-wrap: wrap"
        >
          <div class="title-name" fxFlex="15%;" fxLayoutAlign="center center">
            <mat-label>{{ testBench.displayLoadName }}</mat-label>
          </div>
          <div
            class="tile-details"
            fxLayout="column wrap"
            fxFlex="70%;"
            fxLayoutAlign="center start"
          >
            <div class="row" style="width: 100%">
              <div class="col-md-6 title">
                {{ 'energy.testbenchOverview.testName' | translate }}
              </div>
              <div class="col-md-6 title">
                <span class="title-value">{{ testBench.testName }}</span>
              </div>
            </div>
            <div class="row" style="width: 100%">
              <div class="col-md-6 title">
                {{ 'energy.testbenchOverview.testRunTime' | translate }}
              </div>
              <div class="col-md-6">
                <span class="title-value">{{ testBench.test_RunTime }}</span>
              </div>
            </div>
            <div class="row" style="width: 100%">
              <div class="col-md-6">
                {{ 'energy.testbenchOverview.testbenchRunTime' | translate }}
              </div>
              <div class="col-md-6">
                <span class="title-value">{{
                  testBench.testBench_RunTime
                }}</span>
              </div>
            </div>
            <div class="row" style="width: 100%">
              <div class="col-md-6">
                {{ 'energy.testbenchOverview.testbenchDownTime' | translate }}
              </div>
              <div class="col-md-6">
                <span class="title-value">{{
                  testBench.testBench_DownTime
                }}</span>
              </div>
            </div>
          </div>
          <div fxFlex="15%;" fxLayoutAlign="center center">
            <em class="{{ testBench.loadStateClass }}"></em>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row">
    <div class="col-md-7">
      <div class="col-md-12">
        <mat-label style="font-size: 16px; font-weight: bold"
          >{{ 'energy.testbenchOverview.lastRefreshedOn' | translate }}
          <span class="time-value">{{ testBenchTimestamp }}</span>
        </mat-label>
      </div>
      <div class="col-md-3 last-refresh-item">
        <em class="fa fa-play-circle item-running"></em>
        &nbsp; &nbsp;
        <mat-label class="item-text">{{
          'energy.testbenchOverview.running' | translate
        }}</mat-label>
      </div>
      <div class="col-md-3 last-refresh-item">
        <em class="fa fa-pause-circle item-pause"></em>
        &nbsp; &nbsp;
        <mat-label class="item-text"
          >{{ 'energy.testbenchOverview.stopped' | translate }} ( <
          24h)</mat-label
        >
      </div>
      <div class="col-md-3 last-refresh-item">
        <em class="fa fa-stop-circle item-stop"></em>
        &nbsp; &nbsp;
        <mat-label class="item-text"
          >{{ 'energy.testbenchOverview.stopped' | translate }} ( >
          24h)</mat-label
        >
      </div>
      <div class="col-md-3 last-refresh-item">
        <em class="fa fa-exclamation-circle item-exclamation"></em>
        &nbsp; &nbsp;
        <mat-label class="item-text">{{
          'energy.testbenchOverview.noDataAvailable' | translate
        }}</mat-label>
      </div>
    </div>
  </div>
</mat-expansion-panel>
<mat-expansion-panel
  [expanded]="true"
  *ngIf="testBenchSubItem === benchSubItemEnum.BenchImage"
>
  <mat-expansion-panel-header>
    <div class="row" style="width: 100%">
      <div class="col-md-6">
        <h6>
          <mat-icon class="bosch-ic-settings"></mat-icon>
          {{ 'energy.testbenchOverview.testbenchLayout' | translate }} (
          {{ selectedTestBenchName }} )
        </h6>
      </div>
      <div class="col-md-6" style="text-align: right">
        <button
          id="back"
          class="btn btn-primary"
          matTooltip="{{
            'energy.testbenchOverview.btnStatusTooltip' | translate
          }}"
          (click)="onBack(benchSubItemEnum.BenchImage)"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon>
          {{ 'back' | translate }}
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
  <br />
  <div class="row">
    <div class="col-md-12">
      <div class="col-md-7">
        <div id="wrapper" style="text-align: center; width: 100%">
          <canvas id="loadImgCanvas" width="0" height="0"></canvas>
        </div>
        <mat-label style="font-size: 16px; font-weight: bold"
          >{{ 'energy.testbenchOverview.lastUpdatedOn' | translate }}
          {{ testBenchSensorTimestamp }}</mat-label
        >
      </div>
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-12">
            <mat-label class="label-input" style="font-weight: bold">{{
              'energy.testbenchOverview.testInformation' | translate
            }}</mat-label>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-4">
            <mat-label class="label-input">{{
              'energy.testbenchOverview.testName' | translate
            }}</mat-label>
          </div>
          <div class="col-md-8">
            <mat-label class="label-input test-info-value">{{
              selectedTestBenchData.testName
            }}</mat-label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <mat-label class="label-input">{{
              'energy.testbenchOverview.testRunName' | translate
            }}</mat-label>
          </div>
          <div class="col-md-8">
            <mat-label class="label-input test-info-value">{{
              selectedTestBenchData.test_RunTime
            }}</mat-label>
          </div>
        </div>
        <!-- ------ -->
        <div class="row">
          <div class="col-md-12">
            <mat-label class="label-input" style="font-weight: bold">{{
              'energy.testbenchOverview.primarySensorReadings' | translate
            }}</mat-label>
          </div>
        </div>
        <hr />
        <div class="row" style="line-height: 32px; text-align: center">
          <div
            *ngFor="
              let testBenchRTdata of testBenchSensorRTData.Inlet_FlowChannel
            "
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
          >
            <div
              class="row"
              style="display: flex; align-items: flex-end; flex-wrap: wrap"
            >
              <div class="col-md-5" style="text-align: left">
                <mat-label> {{ testBenchRTdata.name }}</mat-label>
              </div>
              <div class="col-md-7">
                <mat-label class="test-info-value">
                  {{ testBenchRTdata.sensor.sensorReading }}&nbsp;{{
                    testBenchRTdata.sensor.parameterUnit
                  }}
                </mat-label>
              </div>
            </div>
          </div>
        </div>
        <!-- ------ -->
        <div class="row">
          <div class="col-md-12">
            <mat-label class="label-input" style="font-weight: bold">{{
              'energy.testbenchOverview.secondarySensorReadings' | translate
            }}</mat-label>
          </div>
        </div>
        <hr />
        <div class="row" style="line-height: 32px">
          <div
            *ngFor="
              let testBenchRTdata of testBenchSensorRTData.secondaryFlowChannels
            "
            class="col-xs-12 col-sm-12 col-md-4 col-lg-4"
          >
            <div
              class="row"
              style="display: flex; align-items: flex-end; flex-wrap: wrap"
            >
              <div class="col-md-5" style="text-align: left">
                <mat-label> {{ testBenchRTdata.name }}</mat-label>
              </div>
              <div class="col-md-7">
                <mat-label class="test-info-value">
                  {{ testBenchRTdata.sensor.sensorReading }}&nbsp;{{
                    testBenchRTdata.sensor.parameterUnit
                  }}
                </mat-label>
              </div>
            </div>
          </div>
        </div>
        <!-- ------ -->
        <div class="row">
          <div class="col-md-12">
            <mat-label class="label-input" style="font-weight: bold">{{
              'energy.testbenchOverview.trends' | translate
            }}</mat-label>
          </div>
        </div>
        <hr />
        <div class="row" style="display: flex; flex-flow: row; flex-wrap: wrap">
          <div class="col-md-6 col-xs-12 col-sm-12">
            <button
              id="testbench-sensor-trends"
              class="btn btn-primary"
              matTooltip="{{
                'energy.testbenchOverview.sensorTrendsTooltip' | translate
              }}"
              (click)="testBenchTrends()"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="icon"
                class="bosch-ic-efficiency mat-icon Bosch-Ic"
                style="width: max-content"
              ></mat-icon>
              {{ 'energy.testbenchOverview.sensorTrends' | translate }}
            </button>
          </div>
          <div class="col-md-6">
            <button
              id="testbench-ruuning-efficiency"
              class="btn btn-primary"
              matTooltip="{{
                'energy.testbenchOverview.btnTooltip' | translate
              }}"
              (click)="
                getRunningEfficiencyChartForLoad(benchSubItemEnum.BenchImage)
              "
            >
              <mat-icon
                aria-hidden="false"
                aria-label="icon"
                class="bosch-ic-efficiency mat-icon Bosch-Ic"
                style="width: max-content"
              ></mat-icon>
              {{ 'energy.testbenchOverview.runningEfficiency' | translate }}
            </button>
          </div>
        </div>
        <!-- ------ -->
        <div class="row">
          <div class="col-md-12">
            <mat-label class="label-input" style="font-weight: bold">{{
              'energy.testbenchOverview.technicalStaff' | translate
            }}</mat-label>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-5">
            <span class="user-box">
              <img
                class="user-box-img"
                src="./assets/img/Img_Placeholder.png"
                alt="user image"
              />
              <mat-label style="font-weight: bold">Dhiraj</mat-label>
              <mat-label>{{
                'energy.testbenchOverview.engineer' | translate
              }}</mat-label>
            </span>
          </div>
          <div class="col-md-5">
            <span class="user-box">
              <img
                class="user-box-img"
                src="./assets/img/Img_Placeholder.png"
                alt="user image"
              />
              <mat-label style="font-weight: bold">Khan</mat-label>
              <mat-label>{{
                'energy.testbenchOverview.technician' | translate
              }}</mat-label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-expansion-panel>
<mat-expansion-panel
  [expanded]="true"
  *ngIf="testBenchSubItem === benchSubItemEnum.BenchTrends"
>
  <mat-expansion-panel-header>
    <div class="row" style="width: 100%">
      <div class="col-md-6">
        <h6>
          <mat-icon class="bosch-ic-settings"></mat-icon>
          {{ 'energy.testbenchOverview.ATMO1' | translate }}
        </h6>
      </div>
      <div class="col-md-6" style="text-align: right">
        <button
          id="back"
          class="btn btn-primary"
          matTooltip="{{
            'energy.testbenchOverview.btnStatusTooltip' | translate
          }}"
          (click)="onBack(benchSubItemEnum.BenchTrends)"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon>
          {{ 'back' | translate }}
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
  <div class="row" style="display: flex; flex-wrap: wrap; align-items: center">
    <div class="col-md-2" fxLayout="column wrap" fxLayout.xs="column">
      <mat-label class="label-input"
        >{{ 'energy.testbenchOverview.selectPrimarySensors' | translate }}
      </mat-label>
      <mat-form-field>
        <mat-label>{{
          'energy.testbenchOverview.selectSensors' | translate
        }}</mat-label>
        <mat-select
          multiple
          [(ngModel)]="testBenchSensorTrend.selectedSensors"
          [formControl]="selectedSensorsCtr"
        >
          <mat-option
            *ngFor="let item of loadWithAllNodeDetails.inlets"
            [value]="item.name"
            >{{ item.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3" fxLayout="column wrap" fxLayout.xs="column">
      <mat-label class="label-input">{{
        'selectDateRange' | translate
      }}</mat-label>
      <mat-form-field>
        <input
          matInput
          class="datepicker"
          type="text"
          [formControl]="dateRangeCtr"
          ngxDaterangepickerMd
          [(ngModel)]="dateRange"
          [showCustomRangeLabel]="true"
          [alwaysShowCalendars]="true"
          [ranges]="ranges"
          [linkedCalendars]="true"
          [showClearButton]="true"
          (ngModelChange)="onChangeDateRange()"
          [locale]="{ format: 'YYYY-MM-DD' }"
        />
      </mat-form-field>
    </div>
    <div class="col-md-2" fxLayout="column wrap" fxLayout.xs="column">
      <mat-label class="label-input">{{
        'energy.testbenchOverview.selectTest' | translate
      }}</mat-label>
      <mat-form-field>
        <mat-label>{{
          'energy.testbenchOverview.selectSensors' | translate
        }}</mat-label>
        <mat-select
          multiple
          [(ngModel)]="testBenchSensorTrend.selectedSensors"
          [formControl]="selectedSensorsCtr"
        >
          <mat-option
            *ngFor="let item of loadWithAllNodeDetails.inlets"
            [value]="item.name"
            >{{ item.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3" fxLayout="column wrap" fxLayout.xs="column">
      <mat-label class="label-input">{{
        'energy.testbenchOverview.selectSecondarySensors' | translate
      }}</mat-label>
      <mat-form-field>
        <mat-label>{{
          'energy.testbenchOverview.selectSensors' | translate
        }}</mat-label>
        <mat-select
          multiple
          [(ngModel)]="testBenchSensorTrend.selectedSensors"
          [formControl]="selectedSensorsCtr"
        >
          <mat-option
            *ngFor="let item of loadWithAllNodeDetails.inlets"
            [value]="item.name"
            >{{ item.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-2" fxLayout="column wrap" fxLayout.xs="column">
      <mat-label class="label-input">&nbsp;</mat-label>
      <button
        id="testbench-sensortrends"
        class="btn btn-primary"
        style="width: fit-content"
        (click)="generateTestBenchSensorTrends()"
      >
        <mat-icon
          aria-hidden="false"
          aria-label="icon"
          class="bosch-ic-efficiency mat-icon Bosch-Ic"
          style="width: max-content"
        ></mat-icon>
        {{ 'energy.testbenchOverview.generate' | translate }}
      </button>
    </div>
  </div>
  <div class="row">
    <div
      #sensor_trends_chart
      class="sensor-trends-items"
      fxFlex.xs="100%"
      fxLayout="column wrap"
      fxFlex="100%;"
      fxLayoutAlign="start start"
    >
      <div>Chart 1</div>
      <div>Chart 2</div>
    </div>
  </div>
</mat-expansion-panel>
<mat-expansion-panel
  [expanded]="true"
  *ngIf="testBenchSubItem === benchSubItemEnum.BenchRunningEfficiency"
>
  <mat-expansion-panel-header>
    <div class="row" style="width: 100%">
      <div class="col-md-6">
        <h6>
          <mat-icon class="bosch-ic-settings"></mat-icon>
          {{ 'energy.testbenchOverview.runningEfficiency' | translate }}
        </h6>
      </div>
      <div class="col-md-6" style="text-align: right">
        <button
          id="back"
          class="btn btn-primary"
          matTooltip="{{
            'energy.testbenchOverview.btnStatusTooltip' | translate
          }}"
          (click)="onBack(benchSubItemEnum.BenchRunningEfficiency)"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="icon"
            class="bosch-ic-arrow-left-frame"
            style="width: max-content"
          ></mat-icon>
          {{ 'back' | translate }}
        </button>
      </div>
    </div>
  </mat-expansion-panel-header>
  <div
    class="row"
    style="display: flex; flex-wrap: wrap; align-items: center; width: 100%"
  >
    <div class="col-md-4" fxLayout="row wrap" fxLayout.xs="column">
      <mat-label class="label-input"
        >{{ 'energy.testbenchOverview.selectTestbench' | translate }}
      </mat-label>
      &nbsp;
      <mat-form-field style="width: 70%">
        <mat-label>{{
          'energy.testbenchOverview.selectTestbenchOption' | translate
        }}</mat-label>
        <mat-select
          multiple
          [(ngModel)]="testBenchSensorTrend.selectedSensors"
          [formControl]="selectedSensorsCtr"
        >
          <mat-option
            *ngFor="let item of loadWithAllNodeDetails.inlets"
            [value]="item.name"
            >{{ item.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-6" fxLayout="row wrap" fxLayout.xs="column">
      <mat-label class="label-input">{{
        'selectDateRange' | translate
      }}</mat-label>
      &nbsp;
      <mat-form-field style="width: 80%">
        <input
          matInput
          class="datepicker"
          type="text"
          [formControl]="dateRangeRunningCtr"
          ngxDaterangepickerMd
          [(ngModel)]="dateRange"
          [showCustomRangeLabel]="true"
          [alwaysShowCalendars]="true"
          [ranges]="ranges"
          [linkedCalendars]="true"
          [showClearButton]="true"
          (ngModelChange)="onChangeDateRange()"
          [locale]="{ format: 'YYYY-MM-DD' }"
        />
      </mat-form-field>
    </div>
    <div class="col-md-2" fxLayout="row wrap" fxLayout.xs="column">
      <button
        id="testbench-efficiencyChart"
        class="btn btn-primary"
        style="width: fit-content"
      >
        <mat-icon
          aria-hidden="false"
          aria-label="icon"
          class="bosch-ic-efficiency mat-icon Bosch-Ic"
          style="width: max-content"
        ></mat-icon>
        {{ 'energy.testbenchOverview.generateChart' | translate }}
      </button>
    </div>
  </div>
</mat-expansion-panel>
